import { Component, Input, OnInit } from '@angular/core';
import { Product } from 'src/app/_model/product';

@Component({
  selector: 'app-related-products',
  templateUrl: './related-products.component.html',
  styleUrls: ['./related-products.component.scss']
})
export class RelatedProductsComponent implements OnInit {
@Input() relatedProducts: Product[];
  constructor() { }

  ngOnInit(): void {
  }

}
